import { useRef, useCallback } from 'react';

// TODO: Add a story for this hook
/**
 * Wraps an event handler to preserve its reference even if props or state that it uses change
 */
const useStaticHandler = eventHandler => {
  const ref = useRef(() => {});
  ref.current = eventHandler;
  return useCallback(function () {
    return ref.current(...arguments);
  }, [ref]);
};
var useStaticHandler$1 = useStaticHandler;

export { useStaticHandler$1 as default };
//# sourceMappingURL=useStaticHandler.js.map
